/**
 * RETOBLOCK CLOUD PROJECTS MODAL COMPONENT (V1.1)
 * Quản lý danh sách dự án đám mây, lưu/mở/xóa và kiểm soát hạn mức 10 dự án.
 */

import { supabaseService } from '../core/supabase-client.js';

export class CloudProjectsModal {
  constructor(options) {
    this.container = options.container;
    this.projectManager = options.projectManager;
    this.onProjectLoaded = options.onProjectLoaded;
    this.onSaveCurrent = options.onSaveCurrent;
    this.showToast = options.showToast || ((msg) => console.log(msg));

    this.projects = [];
    this.quotaCount = 0;
    this.isLoading = false;
    this.isSaving = false;
    this.currentUser = null;

    this.init();
  }

  init() {
    this.container.innerHTML = `
      <div class="modal-overlay" id="cloud-modal-overlay">
        <div class="modal-card cloud-modal-card">
          <!-- Modal Header -->
          <div class="modal-header">
            <div class="modal-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="modal-title-icon"><path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"/></svg>
              <span>Dự Án Đám Mây (Cloud Projects)</span>
              <span class="badge-v11">V1.1</span>
            </div>
            <button class="btn-modal-close" id="btn-cloud-close" title="Đóng">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
            </button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body cloud-modal-body">
            <!-- Account & Quota Banner -->
            <div class="cloud-user-banner" id="cloud-user-banner">
              <!-- Rendered dynamically -->
            </div>

            <!-- Save Current Project Section -->
            <div class="cloud-save-section" id="cloud-save-section">
              <div class="cloud-save-header">
                <span class="section-title">Lưu dự án hiện tại lên Đám Mây</span>
              </div>
              <div class="cloud-save-form">
                <input type="text" class="cloud-name-input" id="cloud-save-name-input" placeholder="Nhập tên dự án..." maxlength="50" />
                <button class="btn-cloud-save-new" id="btn-cloud-save-new">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
                  <span>Lưu Mới Lên Cloud</span>
                </button>
              </div>
            </div>

            <!-- Cloud Projects List Section -->
            <div class="cloud-list-section">
              <div class="cloud-list-header">
                <span class="section-title">Danh Sách Dự Án Đã Lưu</span>
                <button class="btn-cloud-refresh" id="btn-cloud-refresh" title="Làm mới danh sách">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/><path d="M16 21h5v-5"/></svg>
                  <span>Làm mới</span>
                </button>
              </div>

              <!-- Projects Container -->
              <div class="cloud-projects-container" id="cloud-projects-container">
                <!-- Project items rendered here -->
              </div>
            </div>
          </div>

          <!-- Modal Footer -->
          <div class="modal-footer cloud-modal-footer">
            <span class="cloud-footer-note">Dữ liệu được lưu trữ an toàn theo tiêu chuẩn định dạng nén chuẩn .reto</span>
            <button class="btn-secondary" id="btn-cloud-footer-close">Đóng</button>
          </div>
        </div>
      </div>
    `;

    this.overlay = document.getElementById('cloud-modal-overlay');
    this.bannerEl = document.getElementById('cloud-user-banner');
    this.containerEl = document.getElementById('cloud-projects-container');
    this.nameInput = document.getElementById('cloud-save-name-input');
    this.saveNewBtn = document.getElementById('btn-cloud-save-new');

    this.bindEvents();

    // Lắng nghe auth state từ Supabase
    supabaseService.onAuthStateChange((user) => {
      this.currentUser = user;
      if (this.overlay && this.overlay.classList.contains('active')) {
        this.loadData();
      }
    });
  }

  bindEvents() {
    // Close modal
    const closeBtn = document.getElementById('btn-cloud-close');
    const footerCloseBtn = document.getElementById('btn-cloud-footer-close');
    const handleClose = () => this.hide();

    if (closeBtn) closeBtn.addEventListener('click', handleClose);
    if (footerCloseBtn) footerCloseBtn.addEventListener('click', handleClose);

    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) this.hide();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.overlay.classList.contains('active')) {
        this.hide();
      }
    });

    // Refresh button
    const refreshBtn = document.getElementById('btn-cloud-refresh');
    if (refreshBtn) {
      refreshBtn.addEventListener('click', () => this.loadData());
    }

    // Save New Project Button
    this.saveNewBtn.addEventListener('click', () => this.handleSaveNew());
  }

  show() {
    this.overlay.classList.add('active');
    this.nameInput.value = this.projectManager.getProjectName();
    this.loadData();
  }

  hide() {
    this.overlay.classList.remove('active');
  }

  async loadData() {
    this.currentUser = supabaseService.getUser();
    this.renderBanner();

    if (!this.currentUser) {
      this.containerEl.innerHTML = `
        <div class="cloud-empty-state">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.4"><rect width="18" height="18" x="3" y="3" rx="2"/><circle cx="12" cy="10" r="3"/><path d="M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2"/></svg>
          <p class="empty-title">Chưa kết nối tài khoản đám mây</p>
          <p class="empty-desc">Vui lòng đăng nhập qua cổng RETOZONE để đồng bộ và truy cập danh sách dự án của bạn.</p>
          <a href="${supabaseService.getLoginUrl()}" class="btn-cloud-login-link" target="_blank" rel="noopener">Đăng nhập RETOZONE</a>
        </div>
      `;
      this.saveNewBtn.disabled = true;
      return;
    }

    this.containerEl.innerHTML = `
      <div class="cloud-loading-state">
        <div class="spinner-small"></div>
        <span>Đang đồng bộ danh sách dự án...</span>
      </div>
    `;

    try {
      if (typeof navigator !== 'undefined' && !navigator.onLine) {
        throw new Error('Không có kết nối Internet. Vui lòng kiểm tra đường truyền mạng.');
      }

      const [count, projects] = await Promise.all([
        supabaseService.getProjectsCount(this.currentUser.id),
        supabaseService.listProjects(this.currentUser.id)
      ]);

      this.quotaCount = count;
      this.projects = projects;

      this.renderBanner();
      this.renderProjects();
    } catch (err) {
      console.error('[CloudProjectsModal] loadData error:', err);
      const isFetchErr = err?.message && (err.message.includes('Failed to fetch') || err.message.includes('kết nối đến máy chủ lưu trữ') || err.message.includes('NetworkError'));
      const errorMsg = isFetchErr
        ? 'Không thể kết nối đến máy chủ lưu trữ (Lỗi mạng hoặc cấu hình Cloudflare/Supabase). Vui lòng thử lại sau.'
        : `Không thể kết nối máy chủ đám mây: ${err.message}`;

      this.containerEl.innerHTML = `
        <div class="cloud-error-state">
          <p>${errorMsg}</p>
          <button class="btn-secondary" id="btn-cloud-retry">Thử lại</button>
        </div>
      `;
      const retryBtn = document.getElementById('btn-cloud-retry');
      if (retryBtn) retryBtn.addEventListener('click', () => this.loadData());
    }
  }

  renderBanner() {
    if (!this.currentUser) {
      this.bannerEl.innerHTML = `
        <div class="user-info-row">
          <div class="user-meta">
            <span class="user-role-tag guest">Khách (Offline)</span>
            <span class="user-email-text">Bạn đang thao tác ngoại tuyến trên máy tính.</span>
          </div>
          <a href="${supabaseService.getLoginUrl()}" class="btn-sso-login" target="_blank" rel="noopener">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>
            <span>Đăng nhập</span>
          </a>
        </div>
      `;
      return;
    }

    const quotaPct = Math.min(100, Math.round((this.quotaCount / 10) * 100));
    const isFull = this.quotaCount >= 10;

    this.bannerEl.innerHTML = `
      <div class="user-info-row">
        <div class="user-meta">
          <span class="user-role-tag active">Học Viên</span>
          <span class="user-email-text">${this.currentUser.email || 'Học viên RETOBOTS'}</span>
        </div>
        <div class="quota-meter">
          <div class="quota-label">
            <span>Hạn mức: <strong>${this.quotaCount} / 10</strong> dự án</span>
            ${isFull ? '<span class="quota-tag-full">ĐẦY HẠN MỨC</span>' : ''}
          </div>
          <div class="quota-bar-track">
            <div class="quota-bar-fill ${isFull ? 'full' : ''}" style="width: ${quotaPct}%"></div>
          </div>
        </div>
      </div>
      ${isFull ? `
        <div class="quota-warning-banner">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <span>Tài khoản đã đạt giới hạn 10 dự án. Hãy xóa bớt dự án không dùng để lưu thêm dự án mới.</span>
        </div>
      ` : ''}
    `;

    // Cập nhật trạng thái nút lưu mới
    this.saveNewBtn.disabled = isFull;
    if (isFull) {
      this.saveNewBtn.title = 'Hạn mức đã đầy 10/10 dự án';
    } else {
      this.saveNewBtn.title = 'Lưu dự án hiện tại lên đám mây';
    }
  }

  renderProjects() {
    if (!this.projects || this.projects.length === 0) {
      this.containerEl.innerHTML = `
        <div class="cloud-empty-state">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.4"><path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"/></svg>
          <p class="empty-title">Chưa có dự án nào trên Đám Mây</p>
          <p class="empty-desc">Nhập tên dự án ở trên và bấm "Lưu Mới Lên Cloud" để đồng bộ dự án đầu tiên của bạn!</p>
        </div>
      `;
      return;
    }

    let html = '<div class="cloud-project-grid">';
    for (const p of this.projects) {
      const mode = (p.language_mode || 'scratch').toUpperCase();
      const updatedDate = p.updated_at ? new Date(p.updated_at).toLocaleString('vi-VN') : 'Mới tạo';

      html += `
        <div class="cloud-project-card" data-id="${p.id}" data-path="${p.storage_path}">
          <div class="project-card-header">
            <span class="project-mode-badge ${p.language_mode}">${mode}</span>
            <span class="project-date">${updatedDate}</span>
          </div>
          <div class="project-card-title" title="${p.name}">${p.name}</div>
          <div class="project-card-actions">
            <button class="btn-card-action btn-load-cloud" title="Mở dự án vào không gian làm việc">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              <span>Mở</span>
            </button>
            <button class="btn-card-action btn-overwrite-cloud" title="Ghi đè bằng dự án đang mở trên màn hình">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"/></svg>
              <span>Ghi đè</span>
            </button>
            <button class="btn-card-action btn-download-cloud" title="Tải tệp .reto về máy tính">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            </button>
            <button class="btn-card-action danger btn-delete-cloud" title="Xóa dự án khỏi đám mây">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
            </button>
          </div>
        </div>
      `;
    }
    html += '</div>';

    this.containerEl.innerHTML = html;
    this.bindCardEvents();
  }

  bindCardEvents() {
    const cards = this.containerEl.querySelectorAll('.cloud-project-card');
    cards.forEach((card) => {
      const id = card.getAttribute('data-id');
      const storagePath = card.getAttribute('data-path');
      const project = this.projects.find(p => p.id === id);

      // 1. Mở dự án
      const loadBtn = card.querySelector('.btn-load-cloud');
      if (loadBtn) {
        loadBtn.addEventListener('click', () => this.handleOpenCloudProject(project));
      }

      // 2. Ghi đè dự án
      const overwriteBtn = card.querySelector('.btn-overwrite-cloud');
      if (overwriteBtn) {
        overwriteBtn.addEventListener('click', () => this.handleOverwriteCloudProject(project));
      }

      // 3. Tải về máy
      const downloadBtn = card.querySelector('.btn-download-cloud');
      if (downloadBtn) {
        downloadBtn.addEventListener('click', () => this.handleDownloadLocal(project));
      }

      // 4. Xóa dự án
      const deleteBtn = card.querySelector('.btn-delete-cloud');
      if (deleteBtn) {
        deleteBtn.addEventListener('click', () => this.handleDeleteCloudProject(project));
      }
    });
  }

  async handleSaveNew() {
    if (this.isSaving) return;

    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      this.showToast('Không có kết nối Internet. Vui lòng kiểm tra đường truyền mạng!', 'error');
      return;
    }

    const name = this.nameInput.value.trim();
    if (!name) {
      this.showToast('Vui lòng nhập tên dự án hợp lệ!', 'error');
      return;
    }

    if (this.quotaCount >= 10) {
      this.showToast('Hạn mức đám mây đã đầy (10/10). Hãy xóa bớt dự án cũ!', 'error');
      return;
    }

    this.isSaving = true;
    this.saveNewBtn.disabled = true;
    this.saveNewBtn.textContent = 'Đang lưu...';

    try {
      // Chuẩn bị dữ liệu từ Workspace
      if (this.onSaveCurrent) {
        await this.onSaveCurrent();
      }

      const blob = await this.projectManager.exportCurrentProjectBlob();
      await supabaseService.saveProject({
        name,
        languageMode: this.projectManager.getLanguageMode(),
        blob,
        isUpdate: false
      });

      this.showToast(`Đã lưu dự án "${name}" lên đám mây thành công!`, 'success');
      await this.loadData();
    } catch (err) {
      console.error('[CloudProjectsModal] handleSaveNew error:', err);
      const errMsg = err?.message || '';
      if (errMsg.includes('Failed to fetch') || errMsg.includes('kết nối đến máy chủ lưu trữ') || errMsg.includes('NetworkError')) {
        this.showToast('Không thể kết nối đến máy chủ lưu trữ (Lỗi mạng hoặc cấu hình Cloudflare/Supabase). Vui lòng thử lại hoặc tải dự án về máy (.reto).', 'error');
      } else {
        this.showToast(`Lỗi lưu đám mây: ${errMsg}`, 'error');
      }
    } finally {
      this.isSaving = false;
      this.saveNewBtn.disabled = false;
      this.saveNewBtn.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
        <span>Lưu Mới Lên Cloud</span>
      `;
    }
  }

  async handleOverwriteCloudProject(project) {
    if (this.isSaving) return;

    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      this.showToast('Không có kết nối Internet. Vui lòng kiểm tra đường truyền mạng!', 'error');
      return;
    }

    if (!confirm(`Bạn có chắc chắn muốn GHI ĐÈ dự án "${project.name}" trên đám mây bằng nội dung hiện tại trên màn hình?`)) {
      return;
    }

    this.isSaving = true;
    try {
      if (this.onSaveCurrent) {
        await this.onSaveCurrent();
      }

      const blob = await this.projectManager.exportCurrentProjectBlob();
      await supabaseService.saveProject({
        id: project.id,
        name: this.projectManager.getProjectName(),
        languageMode: this.projectManager.getLanguageMode(),
        blob,
        isUpdate: true
      });

      this.showToast(`Đã ghi đè dự án "${project.name}" trên đám mây!`, 'success');
      await this.loadData();
    } catch (err) {
      console.error('[CloudProjectsModal] handleOverwriteCloudProject error:', err);
      const errMsg = err?.message || '';
      if (errMsg.includes('Failed to fetch') || errMsg.includes('kết nối đến máy chủ lưu trữ') || errMsg.includes('NetworkError')) {
        this.showToast('Không thể kết nối đến máy chủ lưu trữ (Lỗi mạng hoặc cấu hình Cloudflare/Supabase). Vui lòng thử lại hoặc tải dự án về máy (.reto).', 'error');
      } else {
        this.showToast(`Lỗi ghi đè: ${errMsg}`, 'error');
      }
    } finally {
      this.isSaving = false;
    }
  }

  async handleOpenCloudProject(project) {
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      this.showToast('Không có kết nối Internet. Vui lòng kiểm tra đường truyền mạng!', 'error');
      return;
    }

    if (this.projectManager.isDirty) {
      if (!confirm('Dự án hiện tại có thay đổi chưa được lưu. Bạn có muốn mở dự án từ đám mây không?')) {
        return;
      }
    }

    try {
      this.showToast(`Đang tải "${project.name}" từ đám mây...`, 'info');
      const blob = await supabaseService.downloadProjectBlob(project.storage_path);
      await this.projectManager.importProjectFromBlob(blob);

      if (this.onProjectLoaded) {
        this.onProjectLoaded();
      }

      this.hide();
      this.showToast(`Đã mở dự án: ${project.name}`, 'success');
    } catch (err) {
      console.error('[CloudProjectsModal] handleOpenCloudProject error:', err);
      const errMsg = err?.message || '';
      if (errMsg.includes('Failed to fetch') || errMsg.includes('kết nối đến máy chủ lưu trữ') || errMsg.includes('NetworkError')) {
        this.showToast('Không thể kết nối đến máy chủ lưu trữ (Lỗi mạng hoặc cấu hình Cloudflare/Supabase). Vui lòng thử lại hoặc tải dự án về máy (.reto).', 'error');
      } else {
        this.showToast(`Lỗi mở dự án đám mây: ${errMsg}`, 'error');
      }
    }
  }

  async handleDownloadLocal(project) {
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      this.showToast('Không có kết nối Internet. Vui lòng kiểm tra đường truyền mạng!', 'error');
      return;
    }

    try {
      const blob = await supabaseService.downloadProjectBlob(project.storage_path);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${project.name}.reto`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      this.showToast(`Đã tải về tệp ${project.name}.reto`, 'success');
    } catch (err) {
      console.error('[CloudProjectsModal] handleDownloadLocal error:', err);
      const errMsg = err?.message || '';
      if (errMsg.includes('Failed to fetch') || errMsg.includes('kết nối đến máy chủ lưu trữ') || errMsg.includes('NetworkError')) {
        this.showToast('Không thể kết nối đến máy chủ lưu trữ (Lỗi mạng hoặc cấu hình Cloudflare/Supabase). Vui lòng thử lại hoặc tải dự án về máy (.reto).', 'error');
      } else {
        this.showToast(`Lỗi tải tệp: ${errMsg}`, 'error');
      }
    }
  }

  async handleDeleteCloudProject(project) {
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      this.showToast('Không có kết nối Internet. Vui lòng kiểm tra đường truyền mạng!', 'error');
      return;
    }

    if (!confirm(`Bạn có chắc chắn muốn XÓA vĩnh viễn dự án "${project.name}" khỏi đám mây?`)) {
      return;
    }

    try {
      await supabaseService.deleteProject(project.id, project.storage_path);
      this.showToast(`Đã xóa dự án "${project.name}" khỏi đám mây.`, 'success');
      await this.loadData();
    } catch (err) {
      console.error('[CloudProjectsModal] handleDeleteCloudProject error:', err);
      const errMsg = err?.message || '';
      if (errMsg.includes('Failed to fetch') || errMsg.includes('kết nối đến máy chủ lưu trữ') || errMsg.includes('NetworkError')) {
        this.showToast('Không thể kết nối đến máy chủ lưu trữ (Lỗi mạng hoặc cấu hình Cloudflare/Supabase). Vui lòng thử lại hoặc tải dự án về máy (.reto).', 'error');
      } else {
        this.showToast(`Lỗi xóa dự án: ${errMsg}`, 'error');
      }
    }
  }
}
